import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import Banner from "../../../views/components/sections/Banner";
import { usePageDetail, usePageSave } from "../../../hooks/api/page/hooks";
import { getSingleImageUrl } from "../../../lib/utils";
import { useMessageApi } from "../../../provider/AntdNotification";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { useQueryState } from "nuqs";
import ContactDetail from "./contactUs";

const ContactTabs: React.FC<{
  setBreadcrumb: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setBreadcrumb }) => {
  const message = useMessageApi();
  const [tab, setTab] = useQueryState("tab");
  const activeTab = tab || "Banner";
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [pageData, setPageData] = useState<any>(null);

  const { data } = usePageDetail("CONTACT");
  const { mutate: updateService, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        _id: pageData?._id,
        pageType: "CONTACT" as const,
        contact: {
          banner: {
            heading:
              values.banner?.heading ??
              pageData?.contact?.banner?.heading ??
              "",
            image: getSingleImageUrl(
              values.banner?.image ?? pageData?.contact?.banner?.image,
            ),
          },
          heading: values?.heading ??
              pageData?.contact?.heading ??
              "",
          
          subtext: values?.subtext ??
              pageData?.contact?.subtext ??
              "",
          phone: values?.phone ??
              pageData?.contact?.phone ??
              "",
          address: values?.address ??
              pageData?.contact?.address ??
              "",
          
          email: values?.email ??
              pageData?.contact?.email ??
              "",
        },
      };

      updateService(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const sections = ["Banner", "Contact Us"];

  return (
    <div>
      <TabsContain
        sections={sections}
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
      />

      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.contact?.banner}
          loading={isPending}
        />
      )}

      {activeTab === "Contact Us" && (
        <ContactDetail
          contactData={pageData?.contact}
          form={form}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleSave={handleSave}
          handleCancel={handleCancel}
          loading={isPending}
        />
      )}

      
    </div>
  );
};

export default ContactTabs;
